import { Fragment, useEffect, useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setSellerStoreList } from 'v3/data/store/seller/actions';
import { IStoreList } from 'v3/data/store/seller/types';
import { StoresModalPropsType } from 'v3/shared/components/Filters/StoreFilter/Store/types';
import { DividerStyled, FixedElements } from 'v3/shared/components/Filters/StoreSellerFilter/Store/styles';
import { Item } from './item';

export const Stores = ({ searchValue }: StoresModalPropsType) => {
  const [allStoreChecked, setAllStoreChecked] = useState<boolean>(true);
  const { storeList } = useStoreSelector((state) => state.seller);

  const handleStoreClick = (storeSelected) => {
    const storesMapping = storeList.map((store) =>
      store.id === storeSelected.id ? { ...store, checked: !store.checked } : store,
    );
    setSellerStoreList(storesMapping);
  };

  const selectAllStores = () => {
    setAllStoreChecked(!allStoreChecked);
    const selectedStores = storeList.map((store) => {
      return { ...store, checked: !allStoreChecked };
    });
    setSellerStoreList(selectedStores);
  };

  const verifyAllStoresSelected = (storeList: IStoreList[]) => {
    const notAallSelected = storeList.some((item) => item.checked === false);
    if (notAallSelected) {
      setAllStoreChecked(false);
    } else {
      setAllStoreChecked(true);
    }
  };

  useEffect(() => {
    verifyAllStoresSelected(storeList);
  }, [storeList]);

  return (
    <Fragment>
      <FixedElements>
        <Item
          key="select-all-stores"
          store={{ id: 'select-all-stores', name: 'Todas as lojas', checked: allStoreChecked }}
          onClick={selectAllStores}
        />
        <DividerStyled />
      </FixedElements>

      {storeList.map((store) => {
        const storeNameMatch = store.name.toLowerCase().includes(searchValue.toLowerCase());
        const storeCnpjMatch = store.cnpj!.toLowerCase().includes(searchValue.toLowerCase());

        if (storeNameMatch || storeCnpjMatch) {
          return <Item store={store} key={store.id} onClick={handleStoreClick} />;
        }
        return <Fragment />;
      })}
    </Fragment>
  );
};
